<template>
  <b-input-group>
    <b-form-input
        :id="id"
        :placeholder="$t('Search')"
        v-model="internalValue"
        debounce="250"
    />
    <b-input-group-append>
      <b-button @click="internalValue = null">
        <fa icon="times" :title="$t('Reset filter')" />
      </b-button>
    </b-input-group-append>
  </b-input-group>
</template>
<script>
export default {
  name: 'SearchInputGroup',
  props: {
    value: {
      type: String,
      default: null
    },

    id: {
      type: String,
      default: 'search'
    }
  },
  computed: {
    internalValue: {
      get: function() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
